import React, { ComponentProps } from 'react';
import { DefaultView, OptionalEditView, Views } from '../../types/BlockWithViews';
import { ConnectedUsersDefaultView } from './views/ConnectedUsersDefaultView';
import { asFetchableBlock } from '../../_lib/BlockFetcher';
import { BlockType } from '../../types/api/ElementType';
import { ConnectedUsersEditView } from './views/ConnectedUsersEditView';
import { useAppContext } from '../../contexts/AppContext/AppContext';

type ConnectedUsersProps = Views<DefaultView<ConnectedUsersDefaultView> & OptionalEditView<ConnectedUsersEditView>>;

function ConnectedUsers({ views }: ConnectedUsersProps) {
  const {
    editModeInfo: { active },
  } = useAppContext();

  return views.edit && active
    ? (
        <ConnectedUsersEditView {...views.edit} />
      )
    : (
        <ConnectedUsersDefaultView {...views.default} />
      );
}

export const ConnectedUsersBlock = asFetchableBlock(ConnectedUsers, BlockType.connectedUsers);
export type ConnectedUsersBlock = ComponentProps<typeof ConnectedUsersBlock>;
